import * as THREE from 'three';
import { WebCADGlobal } from "../..";
import { ThreeView } from "../../../view3d/webcad";
import { ExtrasType } from "../../../view3d/webcad/WebCadDefines";
import { ItemInfoCollection } from "../../collection";
import WebCADUtil from "../WebCADUtil";
import { ItemDataInterface } from "./json/DataInterface";
import { Raycaster } from './Raycaster';
export class ApplyItem {

    constructor() {}

    public apply(markinfo: ItemInfoCollection, dataList: ItemDataInterface[]): void {
        const intersect = this.getIntersect(markinfo);
        console.log(intersect);
        if (!intersect) return;

        const point = intersect.point;
        const guid = intersect.object?.userData?.guid;
        const type = intersect.object?.userData?.type;
        const face = intersect.face.normal;

        const data = this.getItemData(dataList, type);
        if (!data) return;

        const info = new ItemInfoCollection();
        info.id = data.itemId;
        if (type === ExtrasType.CEILING) {
            info.is_ceiling_item = true;
        }

        info.floor =  markinfo.floor;
        info.guid =   WebCADGlobal.getGuid();

        const extras = ThreeView.get().wcItemmgr.GltfExtras;
        const center = WebCADGlobal.itemManager.changePoint(extras.model_center[0], extras.model_center[1]);
        info.x =      WebCADUtil.convertMMToPix(point.x * 1000 + center.x); // pix
        info.y =      WebCADUtil.convertMMToPix(point.z * 1000 + center.y); // pix
        if (this.isWallType(type)) {
            info.z = point.y * 1000 - data.depth/2; // mm
        }
        info.width =  WebCADUtil.convertMMToPix(data.width);
        info.height = WebCADUtil.convertMMToPix(data.height);
        info.widthmm = data.width;
        info.heightmm = data.height;
        info.depth =  data.depth;

        const zAxis = new THREE.Vector3(0, 0, 1);
        if (this.isWallType(type)) {
            const rad = zAxis.angleTo(face);
            const sin = face.clone().cross(new THREE.Vector3(0, 0, 1));
            const deg = sin.y > 0 ? THREE.MathUtils.radToDeg(rad) : - THREE.MathUtils.radToDeg(rad);
            info.rotation = deg;
        } else {
            info.rotation = 0;
        }

        info.text = data.label;

        WebCADGlobal.itemManager.createItem(info);
    }

    private getItemData(itemDatalist: ItemDataInterface[], type: string): ItemDataInterface {
        return itemDatalist.find((data) => {
            if ((this.isWallType(type) && data.is_wall_item)
            || (type === ExtrasType.CEILING && data.is_ceiling_item)
            || (type === ExtrasType.FLOOR && data.is_floor_item)) {
                return true;
            }
            return false;
        });
    }

    private isWallType(type: ExtrasType): boolean {
        return (type === ExtrasType.KABE) ||
               (type === ExtrasType.KOSI) ||
               (type === ExtrasType.HABAKI);
    }

    /**
     * 衝突判定で取得したアイテム
     */
    protected getIntersect(iteminfo: ItemInfoCollection): THREE.Intersection {
        const isMeshTargetType = (mesh: THREE.Mesh): boolean => {
            return [
                ExtrasType.KABE, ExtrasType.KOSI, ExtrasType.HABAKI, ExtrasType.FLOOR, ExtrasType.CEILING
            ].some((type) => mesh?.userData?.type === type);
        }

        const pos = Raycaster.getPosition(iteminfo);
        const dir = Raycaster.getDirection(iteminfo);

        const raycaster = new THREE.Raycaster(pos, dir);
        const intersectlist = raycaster.intersectObjects(ThreeView.get().wcScene.me.children);

        // this.debug(iteminfo.floor, pos, dir);

        for (let i = 0; i < intersectlist.length; i++) {
            const object = intersectlist[i]?.object;
            if (!object) continue;

            if (object?.userData?.type && isMeshTargetType(<THREE.Mesh>object)) {
                return intersectlist[i];
            }
        }
    }

    // private debug(floor: number, origin: THREE.Vector3, direction: THREE.Vector3) {
    //     const length = 1;
    //     const hex = 0xffff00;
    //     // origin.y = origin.y + ThreeView.get().wcItemmgr.floorToHeight(floor);
    //     const arrowHelper = new THREE.ArrowHelper( direction, origin, length, hex );
    //     ThreeView.get().wcScene.me.add(arrowHelper);
    // }
}